// extracted by mini-css-extract-plugin
export default {"spinner":"NewMarkdownViewer-module__spinner--yFr_i","safe-html-box":"NewMarkdownViewer-module__safe-html-box--dKCgP"};